import http from "@/settings/apiSettings"

class DrepturiCustomDataService {

  get(): Promise<any> {
    return http.clientResurseUmane.get("/Angajati/GetEmployees");
  }

  getByID(id: string): Promise<any> {
    return http.clientResurseUmane.get(`/Angajati/GetEmployeesByID/${encodeURIComponent(id)}`);
  }

  getDepartament(): Promise<any> {
    return http.clientResurseUmane.get("/Angajati/GetPER_StructsWithFullName");
  }

  getAll(): Promise<any> {
    return http.clientResurseUmane.get("/Angajati/getAll");
  }

  save(data: any) : Promise<any> {
    return http.clientResurseUmane.post("/Angajati/add", data)
  }

  saveAdrese(data: any) : Promise<any> {
    return http.clientResurseUmane.post("/Angajati/addAdresa", data)
  }

  update(id: string, dto: any): Promise<any> {
  return http.clientResurseUmane.patch(`/Angajati/${encodeURIComponent(id)}`, dto);
}


}

export default new DrepturiCustomDataService();